import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';
import { ApiService } from '../api.service';

@Component({
  selector: 'app-enroll',
  templateUrl: './enroll.component.html',
  styleUrls: ['./enroll.component.scss']
})
export class EnrollComponent implements OnInit {
  enrollmentList:[];
  active:string;
  bookings = {
    ongoing: [],
    completed: []
  };

  mainData = {
    ongoing: [],
    completed: []
  };


  constructor(private activatedRoute: ActivatedRoute,
    private router: Router,
    private apiService: ApiService) {
     


     }

  ngOnInit() {
    

    let Enrollmentdata = {
      token:localStorage.getItem("token_data"),
      userID:localStorage.getItem("userID"),
      hostID: localStorage.getItem("hostID")

    }

    this.apiService.enrollmentList(Enrollmentdata).subscribe(async (res: any)=>{
      console.log(res);
      //this.enrollmentList = res.data.bookingListData.data;

      for (let i = 0; i < res.data.bookingListData.data.length; i++) {
        const el = res.data.bookingListData.data[i];
        if (el.statusID != 3 && el.statusID != 4 && (el.batchStatus == 1 && el.courseStatus == 1)) {
          this.bookings['ongoing'].push(el);
          this.mainData['ongoing'].push(el);
        } else if (el.statusID === 3 || el.statusID === 4 || el.batchStatus != 1 || el.courseStatus != 1) {
          this.bookings['completed'].push(el);
          this.mainData['completed'].push(el);
        }
      }
      
    }


  
    
    )

}

getBkNumber(bookingID: number) {
  return 'SC-EN-' + bookingID.toString().padStart(8, '0');
}

assessment(){
  this.router.navigateByUrl(`assessment`);
}
userProfile(){
  this.router.navigateByUrl(`userprofile`);
}
dashboard(){    
  this.router.navigateByUrl(`dashboard`);
}
assignment(){
  this.router.navigateByUrl(`assignment`);
}
notice(){
  this.router.navigateByUrl(`notice`); 
}
enquiry(){
  this.router.navigateByUrl(`enquiry`);
}
content(){
  this.router.navigateByUrl(`content`);
}
viewDetails(vendorID,scheduleID,bookingId,partyID){
  
  this.router.navigateByUrl(`enrollment-details/`+ vendorID + `/`+ scheduleID + `/`+ bookingId + `/`+ partyID);
}

calender(){
  this.router.navigateByUrl(`calender`);
}

requirement(){

}
}
